import angular from 'angular';

import routeProviderConfig from './configs/routeProvider.config';

import campaign from './components/campaign/campaign.component';

/**
 * @ngdoc overview
 * @name campaign
 * @description
 * This module handles everything for the Campaign section.
 */
const campaignModule = angular.module('campaign', [])
.config(routeProviderConfig)
.component('campaign', campaign);

export default campaignModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/campaign/index.js